import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Card from '@mui/material/Card';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../interface/ApplicationState';
import { updateLocalUser, validateApiKey } from '../../redux/actions/userActions';
import { alpha, useTheme } from '@mui/material';
import { UserApi } from '../../api/UserApi';
import { useEffect, useState } from 'react';
import { ApiKeyCheckAdornment } from './ApiKeyCheckAdornment';


export const GateIoConnectionSettings = () =>
{
  const dispatch = useDispatch();
  const user = useSelector((state: ApplicationState) => state.userStore.user)
  const theme = useTheme()
  const [ showPass, setShowPass ] = useState(false)

  const isValidatingApiKey = useSelector((state: ApplicationState) => state.userStore.isValidatingApiKey)
  const apiKeyError = useSelector((state: ApplicationState) => state.userStore.apiKeyError)
  const isApiKeyValid = useSelector((state: ApplicationState) => state.userStore.isApiKeyValid)
  useEffect(() => {

    dispatch(validateApiKey())

  }, [user.gateIoApiKey, user.gateIoApiSecret, user.botExchange ])

  return(
    <Card sx={localStyles.card(theme)}>


    <Grid item>
      <TextField
         type={showPass ? "text" : "password"}
         error={!isApiKeyValid && !isValidatingApiKey}
         InputProps={{ startAdornment: <IconButton onClick={() => setShowPass(!showPass)}>{showPass ? <VisibilityOff /> : <Visibility />}</IconButton>, endAdornment: <ApiKeyCheckAdornment isValid={isApiKeyValid} />}} 
         sx={localStyles.input(theme)}
         value={user.gateIoApiKey} 
         fullWidth 
         label={isApiKeyValid ? "Gate.IO API Key" : apiKeyError}
         placeholder="Gate.IO API Key"
         onChange={(e) => dispatch(updateLocalUser({ gateIoApiKey: e.target.value }))} />
    </Grid>

    <Grid item>
      <TextField
        type={showPass ? "text" : "password"}
        error={!isApiKeyValid && !isValidatingApiKey}
        InputProps={{ startAdornment: <IconButton onClick={() => setShowPass(!showPass)}>{showPass ? <VisibilityOff /> : <Visibility />}</IconButton>, endAdornment: <ApiKeyCheckAdornment isValid={isApiKeyValid} />}} 
        sx={localStyles.input(theme)}
        value={user.gateIoApiSecret} 
        fullWidth 
        label={isApiKeyValid ? "Gate.IO API Secret" : apiKeyError}
        placeholder="Gate.IO API Secret"
        onChange={(e) => dispatch(updateLocalUser({ gateIoApiSecret: e.target.value }))}/>
    </Grid>

  </Card>

  )
}

const localStyles = {
  card: (theme: any) => ({
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.02 : 0.5),
    borderRadius: "14px",
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.06 : 0.4)}`,
    padding: 1.25,
    boxShadow: "none",
  }),
  input: (theme: any) => ({
    mb: 1.25,
    '& .MuiOutlinedInput-root': {
      backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.02 : 0.72),
    },
  }),
}
